export default "__VITE_ASSET__vtQCA8Yl__"